import dashboard from './dashboard';
import pages from './pages';
import features from './features';
import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, pages, features]
};

export default menuItems;
